import React, { useState } from "react";
import { Box } from "@mui/system";
import { Typography, Button, Grid } from "@mui/material";
import SearchSelect from "../components/searchAndSelect";
import TableLayout from "../components/table";
import { getOrgsDetails, updateUser } from "../services/httpCalls";
import useNotify from "../utils/useNotify";
import { useNavigate } from "react-router-dom";
import { showloader, orgID } from "../store/gloabalState";
import { useSetRecoilState } from "recoil";
import { OrgFileUpload } from "../components/OrgFileUpload";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";


function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function OrganisationView() {
  const [getState, setState] = React.useState(0);
  const [orgId, setOrgId] = useState();
  const [orgDetails, setOrgDetails] = useState();
  const [orgBankDetails, setOrgBankDetails] = useState();
  const [userList, setUserList] = useState();
  const [userBankList, setuserBankList] = useState();
  const [userAdBankList, setuserAdBankList] = useState();
  // const [showUpdateUserBtn, setShowUpdateUserBtn] = useState(false);
  const [authUsersList, setAuthUsersList] = useState([]);
  const setShowLoader = useSetRecoilState(showloader);
  const OrganizationID = useSetRecoilState(orgID);
  let notify = useNotify();
  let navigate = useNavigate();

  const OnTabSwitch = (event, newValue) => {
    setState(newValue);
  };

  async function orgDetailsGet() {
    if (orgId) {
      setShowLoader(true);
      getOrgsDetails(orgId).then((res) => {
        setOrgDetails(res);
        setUserList(res.userList);
        setuserBankList(res.bankDetailList);
        setuserAdBankList(res.adBankDetailList);
        let authUserList_ = authUsersList;
        res.userList.forEach((elem) => {
          if (elem.isAuthorizer) {
            authUserList_.push(elem.id);
          }
        });
        setAuthUsersList(authUserList_);
        res?.bankDetailList.forEach((bank) => {
          if (bank.status === "ACTIVE") {
            setOrgBankDetails(bank);
          }
        });
        setShowLoader(false);
      });
    } else {
      notify.error("Select Organisation from the list!");
    }
  }

  const selectSearchData = (e) => {
    OrganizationID(e.id);
    setOrgId(e.id);
  };

  const changeAuthUserList = (e) => {
    let userData;
    let userList_ = userList;
    userList_.forEach((elem) => {
      if (elem.id == e) {
        userData = elem;
        if (userData.isAuthorizer) {
          userData.isAuthorizer = false;
        } else {
          userData.isAuthorizer = true;
        }
      }
    });
    updateUser(userData, orgId, e)
      .then(() => {
        notify.success("Successfully updated the user auth flag!");
      })
      .catch(() => {
        notify.error("not able to update the user auth flag!");
      });
  };

  const postUpdateUser = () => {
    let authUsersList_ = authUsersList;
    let userList_ = userList;
    userList_.forEach((user) => {
      authUsersList_.forEach((id) => {
        if (user.id === id) {
          user.isAuthorizer = true;
        } else {
          user.isAuthorizer = false;
        }
      });
    });
    updateUser();
  };
  return (
    <Box sx={{ marginBottom: "1rem" }}>
      <Box sx={{ padding: ".5rem", display: "flex" }}>
        <SearchSelect
          selectSearchData={selectSearchData}
          label={"Select Organisation"}
          name={"orgSelect"}
        />
        <Button
          onClick={orgDetailsGet}
          variant="contained"
          sx={{ margin: ".5rem 1rem" }}
        >
          Submit
        </Button>
      </Box>
      {orgDetails && (
        <Box sx={{ padding: "1rem" }}>
          <Typography
            variant="h5"
            sx={{ paddingBottom: "1rem", fontWeight: 400 }}
          >
            Details of <b>{orgDetails.name}</b>
            <Button
              variant="outlined"
              onClick={() => navigate(`/editorg/${orgDetails.id}`)}
              sx={{ float: "right" }}
            >
              Edit
            </Button>
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  GST State :{" "}
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {orgDetails.gstState ? orgDetails.gstState : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  PAN :
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {orgDetails.panNumber ? orgDetails.panNumber : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Address Line 1 :
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {orgDetails.addresses[0].addressLineOne
                    ? orgDetails.addresses[0].addressLineOne
                    : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  GST Number :
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {orgDetails?.gstNumber ? orgDetails.gstNumber : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Address Line 2 :
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {orgDetails.addresses[0].addressLineTwo
                    ? orgDetails.addresses[0].addressLineTwo
                    : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  City :
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {orgDetails.addresses[0].city ? orgDetails.addresses[0].city : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Country :
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {orgDetails.addresses[0].country
                    ? orgDetails.addresses[0].country
                    : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  State :
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {orgDetails.addresses[0].state ? orgDetails.addresses[0].state : "-"}
                </Typography>
              </Box>
            </Grid>
            {/* <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Bank Name :
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {orgBankDetails.bankName ? orgBankDetails.bankName : "-"}
                </Typography>
              </Box>
            </Grid> */}
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Pincode :
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {orgDetails.addresses[0].pinCode
                    ? orgDetails.addresses[0].pinCode
                    : "-"}
                </Typography>
              </Box>
            </Grid>
            {/* <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  IFSC Code :
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {orgBankDetails.ifscCode ? orgBankDetails.ifscCode : "-"}
                </Typography>
              </Box>
            </Grid> */}
            {/* <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  ADIFSC Code :
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {orgBankDetails.adIfscCode ? orgBankDetails.adIfscCode : "-"}
                </Typography>
              </Box>
            </Grid> */}
            {/* <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Account Number :
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {orgBankDetails.accountNumber
                    ? orgBankDetails.accountNumber
                    : "-"}
                </Typography>
              </Box>
            </Grid> */}
            {/* <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  BSR Code :
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {orgBankDetails.bsrCode ? orgBankDetails.bsrCode : "-"}
                </Typography>
              </Box>
            </Grid> */}
            <Grid item xs={12}>
              <OrgFileUpload orgId={orgId} />
            </Grid>
          </Grid>
        </Box>
      )}
      {userList && (
        <Box sx={{ padding: "1rem", marginBottom: "4rem" }}>
          <Typography
            variant="h6"
            sx={{ paddingBottom: "1rem", fontWeight: 400 }}
          >
            Users of <b>{orgDetails.name}</b>
          </Typography>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={getState} onChange={OnTabSwitch}>
              <Tab label="Organization" {...a11yProps(0)} />
              <Tab label="Bank Details" {...a11yProps(1)} />
              <Tab label="AD Bank Details" {...a11yProps(2)} />
            </Tabs>
          </Box>
          <TabPanel value={getState} index={0}>
            <TableLayout
              transactions={userList}
              type={"users"}
              changeAuthUserList={changeAuthUserList}
            />
          </TabPanel>
          <TabPanel value={getState} index={1}>
            <TableLayout
              transactions={userBankList}
              type={"usersBankDetails"}
            />
          </TabPanel>
          <TabPanel value={getState} index={2}>
            <TableLayout
              transactions={userAdBankList}
              type={"usersAdBankDetails"}
            />
          </TabPanel>
        </Box>
      )}
      {/* {showUpdateUserBtn && (
        <Box className="btn_wrap_bottom">
          <Button onClick={postUpdateUser} variant="contained">
            Update Users List
          </Button>
        </Box>
      )} */}
    
    </Box>
  );
}
